import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import APIUrls from '../../services/APIUrls';
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods';
import Select from 'react-select';
import $ from "jquery";
import {useNavigate } from "react-router-dom";
import { RotatingLines } from 'react-loader-spinner';
import Constants from "../../Constants";
import { SearchIcon } from '../../AppIcons';
import { ConditionalBlock } from '../../ConditionalBlock';
import { textFieldValidation } from '../../ValidationSchema';

export default function GlobalSearch() {
    const { t } = useTranslation();
    const dispatch = new useDispatch();
    const [searchText, setSearchText] = useState("");
    const [searchType, setSearchType] = useState("all");
    const [searchResult, setSearchResult] = useState([]);
    const [errors, setErrors] = useState([]);
    const [showLoader,setShowLoader] = useState(false);
    const [projectCount,setProjectCount] = useState(0);
    const [campaignCount,setCampaignCount] = useState(0);
    const translate = t;
    const navigate = useNavigate();
    const allTypes = [{label:"All",value:"all"},{label:translate("project_listing.projects"),value:"project"},
                    {label:translate("project_listing.campaigns"),value:"campaign"}];
    const search = async(e) =>{
        e?.preventDefault();
        const result = await textFieldValidation.validate({name:searchText},{abortEarly:false})
        .catch((err)=>{
          return err;
        });
        if(!result.errors){
            if(searchText?.length>=3){
                setShowLoader(true);
                let url = `${APIUrls.SEARCH}?text=${searchText.trim()}&type=${searchType}`
                getAxiosResponse(url)
                .then((response)=>{
                    if(response.data.code ===200){
                        const projects = response.data.data?.projects || [];
                        const campaigns = response.data.data?.campaigns || [];
                        let data = [];
                        projects?.forEach((k)=>{
                            data.push({data:k,type:"Project",label:"Projects"});
                        });
                        campaigns?.forEach((k)=>{
                            data.push({data:k,type:"Campaign",label:"Campaigns"});
                        });
                        if(data.length===0){
                            data.push({data: "No matching results",type:"",url:""});
                        }
                        if(data.length>0){
                            setSearchResult(data);
                            setProjectCount(projects.length)
                            setCampaignCount(campaigns.length)
                            inputSearch("open");
                            $(".msg").addClass("hide");
                            if($('div').hasClass('open')){
                            setTimeout(() => {
                                $('.search-result ul li:last-child a').attr('id','lastsearchList')
                                $('.search-result ul li:nth-child(2) a').attr('id','firstsearchList')
                            }, 500);
                            }
                        }else{
                            inputSearch("");
                            
                        }
                        setShowLoader(false);
                    }
                    
                }).catch((err)=>{
                    console.error(err);
                });
            }else {
                inputSearch("");
            }
        }else {
            let dataErrors = {};
                result.inner.forEach((element) => {
                    if(element.type ==="matches"){
                        dataErrors[element.path] = "Oops! No special characters, please.";
                    }else{
                        dataErrors[element.path] = element.message;
                    }
                });
                setErrors(dataErrors);
                inputSearch("");
        }
    };

    const getUrl = (type, name)=>{
        let url = "";
        switch (type) {
            case "Project":
                url = `/projects?id=${name}`;
                break;
            case "Campaign":
                url = `/campaigns?id=${name}`;
                break;
            default:
                break;
        }
        localStorage.setItem("globalSearch",true);
        return url;
    }

    useEffect(()=>{
        if(searchText?.length >=3){
            search();
        }else{
            inputSearch("");
            let dataErrors = {name:""};
            setErrors(dataErrors);
        }
    },[searchType]);

    useEffect(()=>{
        if(searchText?.length <=2){
            inputSearch("");
            let dataErrors = {name:""};
            setErrors(dataErrors);
        }
    },[searchText]);

    const handleNotifyUserChange = (e)=>{
        setSearchType(e.value);
    };

    var inputSearch = (content) => {
        if(content.length === 0){
          $('.search').removeClass('open')
        }
        else{
          $('.search').addClass('open')
        }
    };

    const handleTextChange = (e)=> {
        setSearchText(e.target.value);
    };
   
    const ResultComponent = (prop)=>{
        const result = prop.result;
        const projectCount = prop.projectCount;
        const campaignCount = prop.campaignCount;
        const totalCount = projectCount + campaignCount;
        return (
            <>
            <li className='font-zero m-0' aria-hidden="true"><label htmlFor='searchText'>{totalCount + ' search result found'}</label></li>
            
            {result.map((o,idx)=>
                
                <li key={idx}>
                    {(o.type !=="")?
                        <>
                        <a tabIndex="0" onClick={()=>redirectToPage(o.type,o.data)}>
                            <span>{o.data}</span> {o.label?"in "+o.label:""}
                        </a></> :
                        <label htmlFor='searchText' className='noResult'>{o.data}</label>
                    }
                </li>)}
            </>
        );
    };

    const redirectToPage = (type, data) => {
        const url = getUrl(type, data);
        inputSearch("");
        setSearchText("");
        navigate(url);
    };

    const handleSearchFocusChange = (event) =>{
        if (event.key === Constants.ESCAPE) {
              $('.search').removeClass('open')
              setTimeout(() => {
                $("#searchText").trigger("focus");
              });
        }
        if (event.key === Constants.TAB && event.shiftKey) {
            $('.search').removeClass('open')
          }
    };

    const searchResultLast = (event) =>{
        if (event.key === Constants.ESCAPE) {
              $('.search').removeClass('open')
              setTimeout(() => {
                $("#searchText").trigger("focus");
              });
        }
        if (document.activeElement.id === 'lastsearchList') {
            if (event.key === Constants.TAB && !event.shiftKey) {
               event.preventDefault();
               $('.search').removeClass('open')
               $("#searchText").trigger("focus");
            }
        }
        if (document.activeElement.id === 'firstsearchList') {
            if (event.key === Constants.TAB && event.shiftKey) {
              event.preventDefault();
              $('.search').removeClass('open')
              $("#searchText").trigger("focus");
            }
        }
        
    };
    return (
        <>
            <div className="flex search-with-dropdown">
                <div className="global-dropdown-block" id="globalSearchDropdown">
                    <Select classNamePrefix='cw' className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true} 
                        defaultValue={allTypes[0]}
                        options={allTypes}
                        isSearchable={false}
                        aria-label='search for'
                        onChange={e => handleNotifyUserChange(e)}
                    />
                </div>
                <div className="search">
                    <form onSubmit={(e)=>search(e)}>
                        <input id="searchText" type="text" className="search-control"  name="searchText"
                        placeholder={translate("project_listing.search_something ?")} maxLength={50} autoComplete="off"
                        onChange={(e)=>handleTextChange(e)} 
                        onKeyDown={(e) => handleSearchFocusChange(e)}
                        value={searchText}/>
                        {(searchText.length > 2)? 
                            (<>
                                {showLoader?
                                (
                                    <div className="submit">
                                        <RotatingLines strokeColor="#1D4ED8" strokeWidth="5" animationDuration="0.75" width="22" visible={true} />
                                    </div>
                                ):
                                (<button type="submit" className="submit searchFocus" aria-label="search">
                                    {SearchIcon}
                                </button>)
                                }
                             </>) 
                            :""}
                    </form>
                    <div className="search-result" onKeyDown={(e) => searchResultLast(e)}>
                        <ul>
                            <ResultComponent result={searchResult} projectCount={projectCount} campaignCount={campaignCount} />
                        </ul>
                    </div>
                    <ConditionalBlock condition={errors.name !== undefined}>
                        <label className="error m-0" htmlFor='searchText'>
                            {errors.name}
                        </label>
                    </ConditionalBlock>
                    <ConditionalBlock condition={(searchText.length > 2 && (errors.name === undefined || errors.name === ""))}>
                        <label className="msg m-0" htmlFor='searchText'>
                            Press Enter to Search
                        </label>
                    </ConditionalBlock>
                </div>
            </div>
        </>
    );
}
